import { render, staticRenderFns } from "./TableRowTask.vue?vue&type=template&id=015b560a"
import script from "./TableRowTask.vue?vue&type=script&lang=ts"
export * from "./TableRowTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports